export enum ReportPageObjectModel {
  ReportInfo = 'reportInfo',
  ReportTable = 'reportTable',
  ReportTypeIcon = 'reportTypeIcon',
  ReportDownloadButton = 'reportDownloadButton',
  ReportBreadcrumbs = 'reportBreadcrumbs',
  ReportContent = 'reportContent',
  GeneratingReport = 'generatingReport',
}
